import React from "react";
import { signOut } from "aws-amplify/auth";

function Admin() {
    const handleSignOut = async () => {
        try {
            await signOut();
            // Redirect to home page or login page after sign out
            window.location.href = "/";
        } catch (error) {
            console.error("Error signing out: ", error);
        }
    };

    return (
        <>
            <div className="about-page" data-testid="admin-page">
                <section className="about_section">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h2>Admin page</h2>
                            <button
                                className="btn btn-danger"
                                onClick={handleSignOut}
                                data-testid="sign-out-button"
                            >
                                Sign Out
                            </button>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="about-detail">
                                    <p> je bent nu ingelogd als admin, ga nu naar lessenrooster om aanpassingen te maken </p>
                                    <p> huidige functionaliteit:</p>
                                        <ul>
                                            <li>Aanpassen van lessenrooster</li>
                                            <li>Aanpassen van evenementen</li>
                                            <li>Aanpassen van les categorie</li>
                                        </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
export default Admin; 